"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryIteratorPath = exports.query = void 0;
exports.querySlugFunction = querySlugFunction;
exports.queryTitleFunction = queryTitleFunction;
var _serviceCategory = require("./service-category");
var query = "\n  query {\n    allFishermanBusinessMenuItem(filter: { visible: { eq: true } }, sort: { order: ASC, fields: order }) {\n      nodes {\n        _id\n        name\n        visible\n      }\n    }\n    allFishermanBusinessMenuCategory(sort: { order: ASC, fields: order }) {\n      nodes {\n        _id\n        name\n        items\n      }\n    }\n  }\n";
exports.query = query;
var queryIteratorPath = ['allFishermanBusinessMenuItem', 'nodes'];

// eslint-disable-next-line no-unused-vars
exports.queryIteratorPath = queryIteratorPath;
function querySlugFunction(queryResult) {
  var queryResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var name = queryResult.name,
    _id = queryResult._id;
  var slugifyOptions = {
    replaceSlashes: true
  };
  var _context$fullQuery = context.fullQuery,
    fullQuery = _context$fullQuery === void 0 ? {} : _context$fullQuery,
    slugify = context.slugify;
  var _fullQuery$allFisherm = fullQuery.allFishermanBusinessMenuCategory,
    allFishermanBusinessMenuCategory = _fullQuery$allFisherm === void 0 ? {} : _fullQuery$allFisherm;
  var _allFishermanBusiness = allFishermanBusinessMenuCategory.nodes,
    allCategories = _allFishermanBusiness === void 0 ? [] : _allFishermanBusiness;
  var itemCategory = allCategories.find(function (_ref) {
    var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
    return items.includes(String(_id));
  });
  if (!itemCategory) {
    return slugify(name, slugifyOptions);
  }
  var categorySlugValue = (0, _serviceCategory.querySlugFunction)(itemCategory, allCategories, context);
  return "".concat(categorySlugValue, "/").concat(slugify(name, slugifyOptions));
}

// eslint-disable-next-line no-unused-vars
function queryTitleFunction(queryResult) {
  var queryResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var name = queryResult.name;
  return name;
}